import { useResource } from '@landsbankinn/l16n';
import { ArrowIcon24, RichLink } from '@landsbankinn/ui-kit';
import { res } from './ExternalAuthTypesLink.res';

export function ExternalAuthTypesLink({ label }: { label?: string }) {
  const { r } = useResource();

  return (
    <RichLink
      borderBottom="dotted"
      endIcon={<ArrowIcon24 />}
      href={r(res.link)}
      instrumentAs="rich_link"
      label={label ?? r(res.title)}
      target="_blank"
      labelFontSize="16"
      grow="1"
    />
  );
}
